// extracted by mini-css-extract-plugin
module.exports = {"textA":"textA_textA___8D26"};